/**
 * Stub for nav targets whose real screens land in later units (Contractors
 * in O3, Customers and Insights after). Keeps the shell navigable now.
 */
export function Placeholder({ title, note }: { title: string; note: string }) {
  return (
    <div>
      <h1 className="text-xl font-bold text-charcoal">{title}</h1>
      <div className="mt-4 rounded-2xl border border-dashed border-charcoal/30 bg-white p-8 text-center">
        <p className="text-charcoal">{note}</p>
      </div>
    </div>
  );
}
